// extracted by mini-css-extract-plugin
module.exports = {"icon_container":"IconContainer_icon_container__EEdd4","slop":"IconContainer_slop__N7kdz","visible_hit_slop":"IconContainer_visible_hit_slop__llBmg"};